var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.ownCompany
    ? _c(
        "div",
        { staticClass: "d-flex justify-space-between print-img pt-4" },
        [
          _c("div", [
            _vm.companyName.startsWith("Bergsoe")
              ? _c("img", {
                  attrs: { width: "200px", src: require("@/assets/logo.png") },
                })
              : _c("img", {
                  attrs: {
                    width: "200px",
                    src: require("@/assets/panya-logo.png"),
                  },
                }),
          ]),
          _c("div", { staticClass: "flex-grow-1 text-center" }, [
            _vm.ownCompany.thaiName
              ? _c("div", { staticClass: "text-h6" }, [
                  _vm._v(" " + _vm._s(_vm.ownCompany.thaiName) + " "),
                ])
              : _vm._e(),
            _c("div", { staticClass: "text-h5" }, [
              _vm._v(_vm._s(_vm.ownCompany.englishName)),
            ]),
            _c(
              "div",
              {
                staticClass: "text-caption",
                staticStyle: { "white-space": "pre" },
              },
              [
                _vm._v(" " + _vm._s(_vm.ownCompany.officeAddressEng)),
                _c("br"),
                _vm._v(" " + _vm._s(_vm.ownCompany.officeAddressThai) + " "),
              ]
            ),
            _c("div", { staticClass: "text-caption" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$vuetify.lang.t("$vuetify.packaging.tel")) +
                  " " +
                  _vm._s(_vm.ownCompany.phone1) +
                  " "
              ),
            ]),
          ]),
          _c("div", [
            _c("img", {
              staticStyle: { "margin-top": "15px", "margin-right": "30px" },
              attrs: {
                width: "200px",
                src: require("@/assets/bml-iso-certs.jpeg"),
              },
            }),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }